import { useEffect, useState } from 'react';
import type { FC } from 'react';

import { defineMessages, useIntl } from 'react-intl';

import { Icon } from '@/mastodon/components/icon';
import HourglassIcon from '@/material-icons/400-24px/hourglass.svg?react';

// Self-destructing posts (bolha): "deletes itself in 5h" next to the timestamp.
const messages = defineMessages({
  title: {
    id: 'status.expires',
    defaultMessage: 'Deletes itself on {date}',
  },
  hours: { id: 'status.expires.hours', defaultMessage: '{number}h' },
  minutes: { id: 'status.expires.minutes', defaultMessage: '{number}m' },
});

const MINUTE = 60_000;

export const StatusExpiresAt: FC<{ expiresAt: string }> = ({ expiresAt }) => {
  const intl = useIntl();
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = window.setInterval(() => {
      setNow(Date.now());
    }, MINUTE);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const remaining = Math.max(new Date(expiresAt).getTime() - now, 0);
  const minutes = Math.ceil(remaining / MINUTE);
  const label =
    minutes > 90
      ? intl.formatMessage(messages.hours, { number: Math.round(minutes / 60) })
      : intl.formatMessage(messages.minutes, { number: minutes });

  return (
    <span
      className='status__expires-at'
      title={intl.formatMessage(messages.title, {
        date: intl.formatDate(expiresAt, {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
        }),
      })}
    >
      <Icon id='hourglass' icon={HourglassIcon} />
      {label}
    </span>
  );
};
